import type { FieldValues } from 'react-hook-form';
import * as yup from 'yup';

export enum CompleteAction {
  FLAG_ERROR = 'FLAG_ERROR',
}

export class CompletionTypeField {
  public static fieldName = 'completionType' as const;
  public static options: CompleteAction[] = Object.values(CompleteAction);
  public static validator = yup
    .string()
    .oneOf(CompletionTypeField.options)
    .required();
}

export class ConfirmationNumberField {
  public static fieldName = 'confirmationNumber' as const;
  public static validator = yup.string().required();
}

export class DocumentsFields {
  public static fieldName = 'documents' as const;
  public static validator = yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().ensure().required(),
        displayName: yup.string().optional(),
        documentId: yup.string().ensure().required(),
        sendToClient: yup.boolean().required(),
        showToClient: yup.boolean().optional(),
        check: yup.boolean().optional(),
      }),
    )
    .when(CompletionTypeField.fieldName, {
      is: (action: CompleteAction) => action === CompleteAction.FLAG_ERROR,
      then: (schema) => schema.min(1),
    });
}

export const ProcessWithJurisdictionPermitSchema = yup
  .object()
  .shape({
    [ConfirmationNumberField.fieldName]: ConfirmationNumberField.validator,
    [DocumentsFields.fieldName]: DocumentsFields.validator,
  })
  .required();

export type ProcessWithJurisdictionPermitSchemaType = yup.InferType<
  typeof ProcessWithJurisdictionPermitSchema
>;

export const documentsSchema = yup.object().shape({
  [DocumentsFields.fieldName]: DocumentsFields.validator,
});

export type DocumentsSchemaType = FieldValues &
  yup.InferType<typeof documentsSchema>;
